export const titleContainerStyle = {
  borderBottom: '1px solid $nonInteractiveAuxiliar',
  margin: '$6 $0',
  paddingBottom: '$4'
}
